import bordered from './bordered.json';
import inverted from './inverted.json';
import shadowed from './shadowed.json';
import simple from './simple.json';

export default { simple, inverted, bordered, shadowed };
